const NATURAL_NAMES = Object.freeze({
  bruit: "le bruit blanc",
  oiseaux: "les oiseaux",
  ruisseau: "le ruisseau",
  mer: "les vagues",
  feu: "le feu crépitant",
  pluie: "la pluie",
  tonnerre: "le tonnerre",
  criquets: "les criquets",
  train: "le train",
  bol: "les bols tibétains",
  mouette: "les mouettes et l'océan",
  fan: "le chauffage",
  toundra: "la toundra",
  baleine: "les baleines",
  owl: "la forêt nocturne",
  chat: "le ronronnement",
});

export function buildInsights(data) {
  if (!data?.totalSessions) return [];
  const insights = [];

  if (data.averageEffect >= 1 && data.sessionsWithFeedback >= 3) {
    insights.push({
      priority: 90,
      icon: "↗",
      text: `Après vos moments, votre ressenti progresse en moyenne de +${data.averageEffect.toLocaleString("fr-FR")} point${data.averageEffect >= 2 ? "s" : ""}.`,
    });
  }

  if (data.bestNatural?.id && data.bestNatural.mean > 0.4) {
    const name = NATURAL_NAMES[data.bestNatural.id] || data.bestNatural.id;
    insights.push({
      priority: 80,
      icon: "○",
      text: `C'est avec ${name} que vos ressentis évoluent le mieux pour l'instant.`,
    });
  }

  insights.sort((a, b) => b.priority - a.priority);
  return insights;
}

export function buildConfidenceLine(data, insights = buildInsights(data)) {
  if (!data?.totalSessions) return "";

  const learned = Number(data.learningSessions) || Number(data.completedSessions) || 0;

  if (learned >= 10) return "Votre refuge s'adapte désormais à ce qui vous fait réellement du bien.";
  if (insights.length >= 2) return "Auria relie vos ressentis à ses prochaines propositions.";
  if (learned >= 3) return "Auria commence à reconnaître vos préférences.";
  return "Auria découvre encore ce qui vous accompagne le mieux.";
}
